export type ChatCommand = {
	id: string;
	label: string;
	description?: string;
	command: string;
	aliases?: string[];
	icon: import('lucide-react').LucideIcon;
	disabled?: boolean;
	run: () => void | boolean | Promise<void | boolean>;
};

export function filterChatCommands(
	commands: readonly ChatCommand[],
	value: string,
): ChatCommand[] {
	const query = value.trim().toLowerCase();
	if (!query) return [...commands];
	if (!query.startsWith('/') || /\s/.test(query)) return [];
	return commands.filter(
		(item) =>
			[item.command, ...(item.aliases ?? [])].some((command) =>
				command.startsWith(query),
			) || item.label.toLowerCase().includes(query.slice(1)),
	);
}
